<div class="events-col p-1" [ngClass]="betData.side.includes('b') ? 'back-slip' : 'lay-slip'" *ngIf="betData && betData?.price && betData?.isClosed == false">
    <div id="goto-{{betData?.market_id}}-{{betData?.selection_id}}"></div>
    <div class="bet-table-header gradient position-relative d-none d-md-block">
        <div class="row d-flex align-items-center">
            <div class="col-md-12">
                <div class="game-title-box">
                    <span class="ps-2">Bet Slip</span>
                </div>
            </div>
            <a href="javascript:void(0)" class="live__btn" (click)="onCloseBet($event)">
                <img width="20" class="game-icon-img me-2" src="https://speedcdn.io/assets/parker-client/icons/close.png">
            </a>
        </div>
    </div>
    <div class="bet-slip-content bet-table-body">
        <div class="betslip__div" [ngClass]="betData.side.includes('b') ? 'back-border' : 'lay-border'">
            <div class="ruuner_names mb-md-4">
                {{betData?.event_name}} 
                <div> <b>{{betData.name}} </b></div>
            </div>
            <div class="min_max_ex">
                <small>min: {{kFormatter(betData?.min)}} </small>
                <small>max: {{kFormatter(betData?.max)}} </small>
            </div>
            <div class="row mx-0 mt-2 bet-rows">
                <div class="col-6">
                    <div class="input-group">
                        <label>odds</label>
                        <div class="input-group-text" [ngClass]="{'disabled-cls' : betData.key == 'fancy'}" (click)="onChangeOdds('down')">
                            <i class="fa fa-minus"></i>
                        </div>
                        <input type="number" class="form-control" [disabled]="betData.key == 'fancy'" [(ngModel)]="betData.price" (change)="validateField()" min="1.01" max="999.99">
                        <div class="input-group-text" [ngClass]="{'disabled-cls' : betData.key == 'fancy'}" (click)="onChangeOdds('up')">
                            <i class="fa fa-plus"></i>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <input type="number" pattern="[0-9]*" class="form-control bs_stakes_i" (keypress)="digitOnly($event)" (keydown)="validateField()" (keyup)="validateField()" (change)="validateField()" [(ngModel)]="betData.stake" min="0" placeholder="Stake: 100">
                </div>
            </div>
            <div class="row mx-0 stakes_btns mt-2">
                <div class="col-12">
                    <button type="button" (click)="onAmountChange(stk)" *ngFor="let stk of betData.stakes;"><i class="fa fa-plus"></i> {{stk.name}}</button>
                </div>
                <div class="d_stakesBtns">
                    <a class="btn min-btn" (click)="onMinMaxAmountChange(betData?.min)">MIN</a>
                    <a class="btn max-btn" (click)="onMinMaxAmountChange(betData?.max)">MAX</a>
                    <a class="btn all-btn" *ngIf="isLogin()" (click)="onAllInAmountChange()">ALL IN</a>
                    <a class="btn clear-btn" (click)="onClear()">CLEAR</a>
                </div>
            </div>
            <div class="row mx-0 bet-rows">
                <div class="col-6">
                    <button class="bs_cancel" type="button" (click)="onCloseBet($event)">Cancel</button>
                </div>
                <div class="col-6">
                    <button class="bs_pb" type="button" [disabled]="betData.disabled || isLoading" (click)="orderPlaced()">Submit</button>
                </div>
            </div>
        </div>
    </div>
    <div class="full-overlay" *ngIf="isLoading">
        <app-loader></app-loader>
    </div>
</div>